module.exports = __webpack_public_path__ + "img/3x.58e5191.jpg";